/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { ProtectedAzureWorkloadsContext } from '../contexts/ProtectedAzureWorkloadsContext';

export const useProtectedAzureWorkloadsStore = () => useContext(ProtectedAzureWorkloadsContext);
